import { render, staticRenderFns } from "./BulkUpdateProducerCommissionsModal.vue?vue&type=template&id=bd564f2e&lang=html&"
import script from "./BulkUpdateProducerCommissionsModal.vue?vue&type=script&lang=js&"
export * from "./BulkUpdateProducerCommissionsModal.vue?vue&type=script&lang=js&"
import style0 from "./BulkUpdateProducerCommissionsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports